export default "__VITE_ASSET__xu1VteHN__"